import moment from 'moment';
import 'moment-timezone';

const zone = moment.tz.guess();

const toMoment = iso => moment.tz(iso, zone);

export default { toMoment };
